import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon, ShieldIcon, MessageCircleIcon } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: LockIcon,
    text: 'Pago Seguro'
  }, {
    icon: ShieldCheckIcon,
    text: 'Garantía'
  }, {
    icon: ZapIcon,
    text: 'Descarga Inmediata'
  }, {
    icon: ShieldIcon,
    text: 'Protección de Datos'
  }, {
    icon: MessageCircleIcon,
    text: 'Soporte'
  }];
  return <section className="py-8 bg-[#F5EDE3] border-y border-[#3D2B1F]/10" data-id="element-201">
      <div className="max-w-6xl mx-auto px-4" data-id="element-202">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-203">
          {trustItems.map((item, index) => <div key={index} className="flex items-center gap-3 text-[#9C8578] hover:text-[#C67B30] transition-colors duration-300" data-id="element-204">
              <item.icon className="w-6 h-6" data-id="element-205" />
              <span className="font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-206">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}